import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Button, Group, Stack } from '@mantine/core';

/** Owned by G23 (plan.md S0). Screen-group layout: a sub-nav row + `<Outlet/>` for
 * the sales-invoicing screens (mirrors `purchasing-intake.tsx`'s own layout+Outlet
 * pattern). Includes the genealogy panel on dispatch detail (§9.7) and the
 * "Reverse & clone" affordance on posted dispatches (§4.1). */
export const Route = createFileRoute('/_authenticated/sales-invoicing')({
  component: SalesInvoicingLayout,
});

// Exported so nav.test.ts can assert NAV_SECTIONS' "Sales & Invoicing" children
// mirror this verbatim (label + to + order) rather than drifting silently.
export const TABS: ReadonlyArray<{ to: string; label: string; exact: boolean }> = [
  { to: '/sales-invoicing', label: 'Dispatch a load', exact: true },
  { to: '/sales-invoicing/dispatch-manual', label: 'Dispatch without weighbridge', exact: false },
  { to: '/sales-invoicing/sales-orders', label: 'Sales orders', exact: false },
  { to: '/sales-invoicing/dispatches', label: 'Dispatches', exact: false },
  { to: '/sales-invoicing/raise', label: 'Raise invoices', exact: false },
  { to: '/sales-invoicing/invoices', label: 'Invoices', exact: false },
  { to: '/sales-invoicing/credit-notes', label: 'Credit notes', exact: false },
  { to: '/sales-invoicing/customers', label: 'Customers & prices', exact: false },
];

function SalesInvoicingLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <Stack gap="lg">
      <Group gap="xs" wrap="wrap">
        {TABS.map((tab) => {
          const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to);
          return (
            <Button key={tab.to} component={Link} to={tab.to} variant={active ? 'filled' : 'light'} size="sm">
              {tab.label}
            </Button>
          );
        })}
      </Group>
      <Outlet />
    </Stack>
  );
}
